import { Controller } from "@hotwired/stimulus"

// Confirm-at-the-action-step for turbo:false forms, through the ONE app
// modal (window.appConfirm) - turbo_confirm is dead on forms that opt out
// of Turbo (house rule), so those forms wire this instead (the vet card's
// close-as-botted pattern, generalized). Values:
//   message   - the modal body (required)
//   label     - the confirm button label (optional)
//   unchanged - when the form's select still holds this value, the submit
//               goes straight through: there is nothing to confirm (the
//               main line's ring picker, committee diff review 2026-10-08)
export default class extends Controller {
  static values = { message: String, label: String, title: String, focus: String, unchanged: String }

  connect() {
    // A bfcache back-restore resurrects the page with the latch still set,
    // and the next submit would then skip the confirm entirely (found on
    // the S4A report's twin controller, 2026-09-02; these forms guard
    // deletes and sends, so a skipped confirm is the whole point lost).
    this.boundPageshow = (e) => { if (e.persisted) this.confirmed = false }
    window.addEventListener("pageshow", this.boundPageshow)
  }

  disconnect() {
    window.removeEventListener("pageshow", this.boundPageshow)
  }

  confirm(event) {
    if (this.confirmed) return
    // A submit button carrying data-confirm-skip="true" bypasses the modal
    // (press releases 2026-09-15: "Send me a test" sits in the same form as
    // the real send so the subject line is shared, and a test needs no
    // confirm).
    if (event.submitter?.dataset?.confirmSkip === "true") return
    if (this.hasUnchangedValue && this.element.querySelector("select")?.value === this.unchangedValue) return
    event.preventDefault()
    const options = {}
    if (this.hasLabelValue) options.confirmLabel = this.labelValue
    if (this.hasTitleValue) options.title = this.titleValue
    if (this.hasFocusValue) options.focus = this.focusValue
    // A message may name the client chosen in the form ("Move X to
    // %{client}?"), so the confirm says what the form will do. The client
    // control (shared/_client_picker) shows the chosen name in its text
    // input; a plain select is still honored.
    const picker = this.element.querySelector("[data-controller~='client-picker']")
    const pickedId = picker?.querySelector("input[type='hidden']")?.value
    const sel = this.element.querySelector("select")
    const chosen = pickedId ? picker.querySelector("input[type='text']").value
                 : (sel?.selectedOptions?.[0]?.value ? sel.selectedOptions[0].text : "a client")
    const message = (this.messageValue || "Are you sure?").replace(/%\{client\}/g, chosen)
    window.appConfirm(message, options).then(ok => {
      if (!ok) return
      this.confirmed = true
      this.element.requestSubmit()
    })
  }
}
